import type { CompanyPerformance, OfferTransaction, PerformanceTotals } from '@domain/entities';
import type { PerformanceQuery, PerformanceRepository } from '@domain/repositories';
import type { Page } from '@domain/value-objects';
import type { UseCase } from '../use-case';

export class SearchCompanyPerformance
  implements UseCase<PerformanceQuery, Page<CompanyPerformance>>
{
  constructor(private readonly repo: PerformanceRepository) {}
  execute(query: PerformanceQuery): Promise<Page<CompanyPerformance>> {
    return this.repo.search(query);
  }
}

export class GetPerformanceTotals implements UseCase<void, PerformanceTotals> {
  constructor(private readonly repo: PerformanceRepository) {}
  execute(): Promise<PerformanceTotals> {
    return this.repo.totals();
  }
}

export interface JournalQuery {
  search: string;
  limit: number;
}

export class SearchUsageJournal implements UseCase<JournalQuery, OfferTransaction[]> {
  constructor(private readonly repo: PerformanceRepository) {}
  execute({ search, limit }: JournalQuery): Promise<OfferTransaction[]> {
    return this.repo.journal(search, limit);
  }
}
